import { memo } from 'react';
import { Tooltip } from '@shared/components/Tooltip';
import type { ChipMoreLinkProps } from './types';

/**
 * Figma "Button - textLink" for "+N więcej"
 * Same typography as chip label: #1665C2, 14px, Roboto 500, line-height 20, letter-spacing 0.1
 * Height 32px for vertical alignment with chips.
 * When tooltipContent is provided, hover/focus shows tooltip with full list (e.g. all plan names comma-separated).
 */
const LINK_STYLE = {
  className:
    'inline-flex items-center h-8 justify-center text-[#1665C2] text-sm font-medium leading-5 tracking-[0.1px] shrink-0 cursor-pointer',
  fontFamily: { fontFamily: 'Roboto, sans-serif' } as const,
};

function ChipMoreLinkComponent({
  count,
  label = 'więcej',
  tooltipContent,
  tooltipMaxWidth,
  tooltipMaxHeight,
  className = '',
}: ChipMoreLinkProps) {
  const link = (
    <span
      className={`${LINK_STYLE.className} ${className}`}
      style={LINK_STYLE.fontFamily}
    >
      +{count} {label}
    </span>
  );

  if (tooltipContent) {
    return (
      <Tooltip
        content={tooltipContent}
        triggerWrapContent
        {...(tooltipMaxWidth !== undefined && {
          contentMaxWidth: tooltipMaxWidth,
          useContentWidth: true,
        })}
        {...(tooltipMaxHeight !== undefined && {
          contentMaxHeight: tooltipMaxHeight,
        })}
      >
        {link}
      </Tooltip>
    );
  }

  return link;
}

export const ChipMoreLink = memo(ChipMoreLinkComponent);
